import api from '@/api';

const resource = 'merenda/grupos-preparacao';

export default {
  criarGrupoPreparacao( data ) {
    return api.post( `${resource}`, data );
  },

  editarGrupoPreparacao( data ) {
    return api.put( `${resource}/${data.identificadorgrupopreparacao}`, data);
  },

  deletarGrupoPreparacao( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarGrupoPreparacao() {
    return api.get( `${resource}` );
  }
};
